import AdvertiseIntroduction from "@/views/home-wrapper/advertise/AdvertiseIntroduction.vue";
import IntroductionDetail from "@/views/home-wrapper/advertise/IntroductionDetail.vue";
import CommunitySeeking from "@/views/home-wrapper/community/CommunitySeeking.vue";
import { setMeta } from "./js/meta";
export default {
  components: {
    AdvertiseIntroduction,
    IntroductionDetail,
    CommunitySeeking
  },
  mixins: [require("../../router/ssr_mixin")],
  data() {
    return {
      title: "Influencer marketing and adveritse with content creators | linkr.com",
      description: "Linkr: marketing with Linkr creators! We connect business brands to the right linkr creators and social influencers."
    };
  },
  created() {
    setMeta("twitter:title", this.title, false);
    setMeta("twitter:description", this.description, false);
    setMeta("og:title", this.title, true);
    setMeta("og:description", this.description, true);
  }
};